import { html, strMap } from 'fxjs/es';

export const makeCustomSelectorHtml = ({ title, items, className }) => {
  const DEFAULT_TEXT = '선택하세요';
  const RESET_TEXT = '초기화';

  // items가 배열이 아닌 경우 에러
  if (!Array.isArray(items)) {
    throw new Error('items must be an array');
  }

  // items의 모든 요소가 필수 속성을 가지고 있는지 검증
  const hasRequiredProps = items.every((item) => item && 'id' in item && 'value' in item && 'name' in item);

  if (!hasRequiredProps) {
    throw new Error('All items must have id, value, and name properties');
  }

  const selectedItem = items.find((item) => item.is_selected === true);
  const selectedText = selectedItem ? selectedItem.name : DEFAULT_TEXT;

  return html`
    <div class="custom-select-box ${className}">
      <div class="title">${title}</div>
      <div
        class="select-selected"
        ${selectedItem ? `data-value="${selectedItem.value}" data-id="${selectedItem.id}"` : ''}
      >
        ${selectedText}
      </div>
      <div class="select-items">
        <div class="select-option select-option-reset" data-value="" data-id="">${RESET_TEXT}</div>
        ${strMap(
          (item) =>
            html` <div
              class="select-option ${item.is_selected ? 'selected' : ''}"
              data-value="${item.value}"
              data-id="${item.id}"
            >
              ${item.name}
            </div>`,
          items,
        )}
      </div>
    </div>
  `;
};

export const makeCustomTextInputHtml = ({ title, value, className, placeholder }) => {
  return html`
    <div class="custom-text-input-box ${className}">
      <div class="title">${title}</div>
      <input type="text" value="${value}" placeholder="${placeholder}" />
    </div>
  `;
};

// 가로선
export const width100HorizontalLine = ({ margin_bottom = '0', margin_top = '0' }) => {
  return html`
    <div
      style="width: 100%; height: 1px; background-color: #e5e5e5; margin-bottom: ${margin_bottom}; margin-top: ${margin_top};"
    ></div>
  `;
};
